import { hoyLocal } from '../utils/fechaLocal';
// Tipos y constantes compartidos del módulo de Equipos y herramientas (norma MA-CAL-02)
export interface Spec { label: string; value: string; }
export interface Asset {
  id: string; clase: string; area: string; correlativo: number; code: string;
  description: string; marca?: string; modelo?: string; specs: Spec[];
  ubicacionFisica?: string; estado: string; fechaAlta?: string; responsable?: string;
  fotoDriveId?: string; fichaDocId?: string; nroSerie?: string; proveedor?: string;
  fechaCompra?: string; garantia?: string; qrToken: string; notes?: string;
}
export interface Maint {
  id: string; fecha?: string; rutina?: string; responsable?: string; observaciones?: string;
  tipo?: string; nuevoEstado?: string; fechaProgramada?: string;
  frecuenciaValor?: number; frecuenciaUnidad?: string; completado?: number;
}

export const CLASES = [{ value: 'EQ', label: 'EQ · Equipo' }, { value: 'HE', label: 'HE · Herramienta' }];
export const AREAS = [
  { value: 'ADM', label: 'ADM · Administración' }, { value: 'CAL', label: 'CAL · Calidad' },
  { value: 'COM', label: 'COM · Comercial' }, { value: 'DET', label: 'DET · Detailing' },
  { value: 'GOM', label: 'GOM · Gomería' }, { value: 'LAV', label: 'LAV · Lavadero' },
  { value: 'LUB', label: 'LUB · Lubricentro' }, { value: 'MEC', label: 'MEC · Mecánica' },
  { value: 'RH', label: 'RH · Recursos Humanos' }, { value: 'GRL', label: 'GRL · General / compartido' },
];
export const AREA_LABEL: Record<string, string> = Object.fromEntries(AREAS.map(a => [a.value, a.label.split(' · ')[1]]));
export const ESTADOS = [
  { value: 'borrador', label: 'Borrador (ficha incompleta)' },
  { value: 'operativo', label: 'Operativo' },
  { value: 'en_reparacion', label: 'En reparación' },
  { value: 'de_baja', label: 'De baja' },
];
export const ESTADO_LABEL: Record<string, string> = Object.fromEntries(ESTADOS.map(e => [e.value, e.label]));
export const ESTADO_BADGE: Record<string, string> = {
  borrador: 'bg-blue-500/15 text-blue-600 dark:text-blue-400',
  operativo: 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-400',
  en_reparacion: 'bg-amber-500/15 text-amber-600 dark:text-amber-400',
  de_baja: 'bg-slate-500/15 text-slate-500 dark:text-slate-400',
};
export const RUTINAS = ['Rutina A', 'Rutina B', 'Rutina C', 'Servicio', 'Reparación', 'Otro'];
export const pad2 = (n: number) => String(n).padStart(2, '0');
export const today = () => hoyLocal();
